import apiCache from '../services/ApiCache';

/**
 * Миксин для работы с кэшированием API запросов
 */
export default {
    methods: {
        /**
         * Выполнить кэшированный API запрос
         * @param {string} key - ключ кэша
         * @param {Function} requestFn - функция для выполнения запроса
         * @param {number} ttl - время жизни кэша в миллисекундах
         * @returns {Promise}
         */
        async cachedApiRequest(key, requestFn, ttl) {
            return apiCache.get(key, requestFn, ttl);
        },

        /**
         * Получить media object с кэшированием
         * @param {number} mediaId - ID медиа объекта
         * @returns {Promise}
         */
        async getCachedMediaObject(mediaId) {
            const key = `media_objects_${mediaId}`;
            return this.cachedApiRequest(key, () => {
                return this.axios.get(`media_objects/${mediaId}`, {
                    params: { hideLoader: true }
                }).then(res => res.data);
            }, 2 * 60 * 1000); // 2 минуты кэш для media objects
        },

        /**
         * Получить модуль с кэшированием
         * @param {number} moduleId - ID модуля
         * @param {Object} params - параметры запроса
         * @returns {Promise}
         */
        async getCachedModule(moduleId, params = {}) {
            const key = `modules_${moduleId}_${JSON.stringify(params)}`;
            return this.cachedApiRequest(key, () => {
                return this.axios.get(`modules/${moduleId}`, { params }).then(res => res.data);
            }, 5 * 60 * 1000); // 5 минут кэш для модулей
        },

        /**
         * Инвалидировать кэш модуля
         * @param {number} moduleId - ID модуля
         */
        invalidateModuleCache(moduleId) {
            apiCache.invalidatePattern(`modules_${moduleId}`);
        },

        /**
         * Инвалидировать кэш media object
         * @param {number} mediaId - ID медиа объекта
         */
        invalidateMediaObjectCache(mediaId) {
            apiCache.invalidate(`media_objects_${mediaId}`);
        },

        /**
         * Инвалидировать кэш курса
         * @param {number} courseId - ID курса
         */
        invalidateCourseCache(courseId) {
            apiCache.invalidatePattern(`courses_${courseId}`);
        }
    }
};
